import { ActionTypes } from 'shared/constants';

export default (state = [], action) => {
  switch (action.type) {
    case ActionTypes.FETCH_HIGHLIGHTS_SUCCESS:
      return action.payload.highlights;
    default:
      return state;
  }
};
